import React, { useMemo } from 'react';
import { StyleSheet, View } from 'react-native';
import Head from 'expo-router/head';
import * as AppConstants from '@/utilities/AppConstants';
import * as AppUtilities from '@/utilities/AppUtilities';
import { BasicWrapperView } from '@/components/BasicWrapperView';
import { RabblsSearch } from '@/components/RabblsSearch';
import { Link } from 'expo-router';
import { Button } from 'react95-native-rabbl';
import Footer from '@/components/Footer';
import { useBottomTabBarHeight } from "expo-router/js-tabs";
import { Meta } from '@/components/Meta';

const styles = StyleSheet.create({
  createButton: {
    paddingTop: 20,
    alignItems: 'center',
  },
});

function FooterComponent() : React.ReactNode {
  return (
    <>
      <View style={styles.createButton}>
        <Link href="/rabbls" asChild={true} className={"nontext"}>
          <Button>Create your own Rabbl</Button>
        </Link>
      </View>
      <Footer />
    </>
  );
}

export default function FindRabbl() {
  const footer = useMemo(() => <FooterComponent />, []);
  const tabBarHeight = useBottomTabBarHeight();

  return (
    <BasicWrapperView center={false} style={AppConstants.STYLES.noHorizontalMargin}>
      <Meta title={"Find a Rabbl"} />
      <RabblsSearch footer={footer} extraUnusableHeight={tabBarHeight} />
    </BasicWrapperView>
  );
}
